import { DataStore } from 'common/module/data/store';
import { TextTrimControlsTemplatePropsInterface } from 'common/module/text-trim/controls/template-props.interface';

export class TextTrimControlsViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: TextTrimControlsTemplatePropsInterface;

  /**
   * @inheritDoc
   */
  public initialize(options: TextTrimControlsTemplatePropsInterface): void {
    this.state = options;
  }

  /**
   * @inheritDoc
   */
  public getState(): TextTrimControlsTemplatePropsInterface {
    return this.state;
  }

  /**
   * Hide controls
   */
  public hide(): void {
    this.state.isVisible = false;
    this.setState(this.state);
  }

  /**
   * Show controls
   */
  public show(): void {
    this.state.isVisible = true;
    this.setState(this.state);
  }

  /**
   * Set expanded
   */
  public setExpanded(isExpanded: boolean): void {
    this.state.isExpanded = isExpanded;
    this.setState(this.state);
  }
}
